<div>
  <header class="header modal-header flex flex-col gap-2 place-content-between h-16">
    <div class="flex justify-between">
      <h3 class="py-1" i18n>READY FOR TAKE-OFF?</h3>
      <button mat-icon-button class="button-close" (click)="closeModal()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>
  <div class="action-items">
    <p class="mb-8 text-xs" i18n>Take off with the Media Lounge. Register and use other extra features such as recommending pictures or videos and creating personal collections</p>
    <div class="action-buttons text-center">
      <div class="register-button my-6">
        <button class="w-48 lg:w-auto button-primary" (click)="closeModal('Register')" mat-flat-button type="button" i18n>Register</button>
      </div>
      <div class="divider"><span class="line"></span> <span class="divider-text" i18n>or</span> <span class="line"></span></div>
      <div class="login-button my-6">
        <button class="w-48 lg:w-auto button-primary" (click)="closeModal('Login')" mat-flat-button type="button" i18n>Log in</button>
      </div>
    </div>
  </div>
  <div class="w-full">
    <div class="text-center">
      <a class="cursor-pointer mx-4 underline" (click)="closeModal()" i18n>No, continue as guest</a>
    </div>
  </div>
</div>
